import styled from 'styled-components';
import { StyleColor, NewStyleColor } from '../../utils/styles-constants';
import { ButtonsList, Button } from '../ResourceSelector/styles';
import { Wrapper, Bar } from '../ResourceSelector/ProgressBar/styles';

const PopupBodyWrapper = styled('div')`
	margin-bottom: 10px;

	${ButtonsList} li:not(:last-child) {
		margin-bottom: 0;

		${Button} {
			border-bottom: 1px solid ${NewStyleColor.Grey300};
		}
	}

	${Button} {
		height: 50px;
		padding: 0;
		border-radius: 0;
		font-size: 14px;
		line-height: 50px;
		color: ${StyleColor.Black};
	}

	${Wrapper} {
		margin: 20px;
	}

	${Bar} {
		background-color: ${StyleColor.Grey100};
	}
`;

export { PopupBodyWrapper };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalCreator/styles.ts